import { observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'

export type SkillTagProps = ModelProps<SkillTag>

export class SkillTag extends Model<SkillTag> {
  id = Id.none
  @observable accessor label = ''
  @observable accessor color = ''
  @observable accessor workspaceId = Id.none
}
